import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/Button';
import { Card, CardContent } from '../components/ui/Card';
export function EditSectionQuestion() {
  const {
    id
  } = useParams();
  const navigate = useNavigate();
  const isEdit = !!id;
  return <div className="space-y-4" data-id="element-849">
      <div className="flex items-center justify-between" data-id="element-850">
        <h1 className="text-2xl font-bold text-slate-900" data-id="element-851">
          {isEdit ? 'Edit Section Question' : 'Add Section Question'}
        </h1>
        <Button variant="secondary" size="sm" className="border border-slate-300 bg-gradient-to-b from-white to-slate-100 text-slate-700 shadow-sm" onClick={() => navigate('/questions')} data-id="element-852">
          ← Back to Questions
        </Button>
      </div>

      <Card data-id="element-853">
        <CardContent className="pt-6" data-id="element-854">
          <form className="space-y-5 max-w-2xl" data-id="element-855">
            <div data-id="element-856">
              <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-857">
                Course
              </label>
              <select className="h-8 rounded border border-slate-300 bg-white px-2 text-sm focus:outline-none focus:ring-2 focus:ring-slate-400 min-w-[200px]" defaultValue={isEdit ? '1' : ''} data-id="element-858">
                <option value="" data-id="element-859">-- Select Course --</option>
                <option value="1" data-id="element-860">Desert Ecology Basics</option>
                <option value="2" data-id="element-861">Advanced Water Conservation</option>
                <option value="3" data-id="element-862">Sustainable Landscaping</option>
              </select>
            </div>

            <div data-id="element-863">
              <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-864">
                Section
              </label>
              <select className="h-8 rounded border border-slate-300 bg-white px-2 text-sm focus:outline-none focus:ring-2 focus:ring-slate-400 min-w-[160px]" defaultValue={isEdit ? '1' : ''} data-id="element-865">
                <option value="" data-id="element-866">-- Select Section --</option>
                <option value="1" data-id="element-867">Section 1</option>
                <option value="2" data-id="element-868">Section 2</option>
                <option value="3" data-id="element-869">Section 3</option>
              </select>
            </div>

            <div data-id="element-870">
              <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-871">
                Question
              </label>
              <textarea className="w-full min-h-[100px] rounded border border-slate-300 bg-white p-2 text-sm focus:outline-none focus:ring-2 focus:ring-slate-400 resize-y" defaultValue={isEdit ? 'What is the primary water source for desert flora?' : ''} data-id="element-872" />
            </div>

            <div data-id="element-873">
              <label className="block text-sm font-medium text-slate-700 mb-2" data-id="element-874">
                Answer
              </label>
              <div className="flex items-center gap-6" data-id="element-875">
                <label className="flex items-center gap-2 cursor-pointer" data-id="element-876">
                  <input type="radio" name="answer" value="yes" defaultChecked={isEdit} className="focus:ring-slate-400" data-id="element-877" />
                  <span className="text-sm text-slate-700" data-id="element-878">Yes</span>
                </label>
                <label className="flex items-center gap-2 cursor-pointer" data-id="element-879">
                  <input type="radio" name="answer" value="no" className="focus:ring-slate-400" data-id="element-880" />
                  <span className="text-sm text-slate-700" data-id="element-881">No</span>
                </label>
              </div>
            </div>

            <div className="pt-2" data-id="element-882">
              <Button type="submit" data-id="element-883">Submit</Button>
            </div>
          </form>
        </CardContent>
      </Card>
    </div>;
}